'use client';

import React from 'react';
import { PulseButton } from 'src/components/PulseUI/PulseButton';
import { Pagination, ResultsHeader, ResultsList } from './components';
import { useResultsList } from './context';
import useDiscoveryEntityTypeLabel from 'src/hooks/discovery/useDiscoveryEntityTypeLabel';

const ResultsPanel = () => {
  const { state, dispatch } = useResultsList();
  const isGreaterThanOne = state.selectedProviders.length > 1;
  const itemLabel = useDiscoveryEntityTypeLabel(
    isGreaterThanOne ? 'plural' : 'singular'
  );

  const handleAddToLists = () => {
    dispatch({ type: 'SET_SHOW_ADD_TO_LISTS_DIALOG', payload: true });
  };

  return (
    <div className="h-full w-base2 flex-shrink-0 flex flex-col bg-white shadow-xl overflow-hidden">
      {/* Content - mirrors Drawer.Content */}
      <div className="flex-1 flex flex-col min-h-0 overflow-y-auto bg-white">
        <ResultsHeader />
        <ResultsList />
      </div>
      {/* Footer - mirrors Drawer.Footer */}
      <div className="shrink-0 w-full bg-white border-t border-neutral-200 flex flex-col justify-center items-start">
        {state.selectedProviders.length > 0 && (
          <div className="w-full h-14 pt-4 px-4 inline-flex justify-between items-center">
            <PulseButton
              variant="solid"
              size="md"
              className="w-full rounded-full bg-sky-600 text-white"
              onClick={handleAddToLists}
            >
              {`Add ${state.selectedProviders.length} ${itemLabel} to List`}
            </PulseButton>
          </div>
        )}
        <Pagination />
      </div>
    </div>
  );
};

export default ResultsPanel;
